export const langTry = {
  fr: {
    add: 'Ajouter une session',
    test: 'Utiliser un fichier gps',
    see: 'Voir les stats',
    save: 'Enregistrer',
    apply: 'Appliquer',
    cancelAll: 'Tout annuler',
    open1: 'Commencez par choisir et ouvrir un',
    opengpx: 'fichier .gpx',
    open2: ' ou un',
    openfit: 'fichier .fit',
    open3: `Vous pouvez également jeter un coup d'oeil à ce`,
    openexample: 'petit exemple',
    open4: `si vous souhaitez simplement vous faire une idée des possibilités offertes.`,
    convert:
      'Les données du fichier sont converties en carte de localisation du tracé gps et en graphe donnant la vitesse en fonction du temps.',
    delete1:
      'Si nécessaire, supprimez les points qui ne doivent pas être conservés.',
    delete2:
      "Vous pouvez par exemple supprimer le début ou la fin de l'enregistrement gps, ou des parties intermédiaires correspondant à de longues pauses dans votre session.",
    delete3:
      "Cette étape n'est pas obligatoire, vous pouvez choisir de poursuivre simplement en cliquant sur ",
    delete4:
      'Pour supprimer une partie de la session, positionnez le slider rouge sous la période concernée, puis cliquez sur ',
    delete5:
      ' à droite du slider. Ajustez ensuite la largeur du nouveau slider pour délimiter précisément la période que vous souhaitez supprimer. Votre sélection apparaît également sur la carte.',
    delete6:
      'Vous pouvez cumuler les parties à supprimer en répétant ces étapes, ou annuler une sélection en cliquant sur ',
    delete7: ' à droite du slider.',
    delete8: 'Une fois terminé, cliquez sur ',
    delete9:
      '. Les points sélectionnés sont supprimés de la carte et du graphe.',
    delete10:
      'Pour tout annuler et revenir aux données de départ, cliquez sur ',
    delete11: 'Lorsque vous avez terminé, cliquez sur ',
    stat1:
      'Outre les cartes et graphes, vous accédez aux stats relatives à votre session.',
    stat2: 'Les ',
    stat3: 'utilisateurs enregistrés ',
    stat4:
      'peuvent stocker leurs sessions et les compléter avec des infos relatives aux gréements utilisés et aux données météo des stations winds.mobi proches.',
    stat41:
      ' ont également accès à des stats globales, à un calendrier des sessions et à une carte animée permettant de revoir chaque session.',
    stat5:
      ' peuvent ajouter à chaque session stockée des données relatives aux ',
    stat6: ' condtions de vent ',
    stat7: ' et aux ',
    stat8: ' équipements utilisés ',
    stat9:
      "Vous pourrez de cette façon comparer vos sessions selon les conditions du jour et avoir une idée du temps d'utilisation de vos boards, voiles et ailes.",
    stat10:
      'Vous pourrez également visualiser un calendrier de vos sessions et une carte animée vous permettant de revoir chacune de vos sessions.',
    connect1: 'Cliquez',
    connect2: "ici pour consulter un petit exemple d'utilisateur enregistré.",
    connect3: ' Vous pouvez également',
    connect4: 'créer un compte pour commencer à enregistrer vos sessions',
    connect5: ", c'est gratuit.",
    example: `Exemple`,
    sessionExample: `Session exemple`,
  },
  eng: {
    add: 'Add a session',
    test: 'Use GPS file',
    see: 'View stats',
    save: 'Save',
    apply: 'Apply',
    cancelAll: 'Cancel all',
    open1: 'Start by choosing and opening a',
    opengpx: '.gpx file',
    open2: ' or a',
    openfit: '.fit file',
    open3: 'You can also take a look at',
    openexample: 'this short example',
    open4: ' if you just want to get an idea of what is possible.',
    convert:
      'The data in the file is converted into a location map of the GPS plot and into a graph giving speed as a function of time.',
    delete1: 'If necessary, delete points that are not to be retained.',
    delete2:
      'For example, you can delete the beginning or end of the GPS recording, or intermediate parts corresponding to long breaks in your session.',
    delete3:
      'This step is not required, you can choose to just continue by clicking ',
    delete4:
      'To delete a part of the session, position the red slider under the relevant period, then click ',
    delete5:
      ' to the right of the slider. Then adjust the new slider width to precisely delimit the period you want to delete. Your selection also appears on the map.',
    delete6:
      'You can cumulate the parts to be deleted by repeating these steps, or cancel a selection by clicking ',
    delete7: ' to the right of the slider.',
    delete8: 'When finished, click ',
    delete9: '. Selected points are removed from the map and from the graph.',
    delete10: 'To cancel all and return to the original data, click ',
    delete11: 'When you are finished, click ',
    stat1:
      'In addition to maps and graphs, you can access stats related to your session.',
    stat2: '',
    stat3: 'Registered users',
    stat4:
      ' can store their sessions and supplement them with information about the rigging used and the weather data of nearby wind.mobi stations. ',
    stat41:
      ' also have access to global stats, a calendar of sessions and an animated map to review each session.',
    stat5: ' can add to each session stored data related to ',
    stat6: ' wind conditions ',
    stat7: ' and ',
    stat8: ' equipments used ',
    stat9:
      'This way you can compare your sessions according to the conditions of the day and have an idea of the time of use of your boards, sails and wings.',
    stat10:
      'You can also view a calendar of your sessions and an animated map allowing you to review each of your sessions.',
    example: `Example`,
    sessionExample: `Session example`,
  },
}
